import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "chart-container" }
const _hoisted_2 = { class: "header-container" }
const _hoisted_3 = { class: "dataset-selector" }
const _hoisted_4 = { class: "selector-group" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "selector-group" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "upload-btn-wrapper" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 1,
  class: "loading-content"
}
const _hoisted_12 = { class: "upload-btn-wrapper" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 0,
  style: {"padding":"12px 0"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[16] || (_cache[16] = _createElementVNode("img", {
        src: "/rulescope.svg",
        alt: "RuleScope",
        class: "rulescope-title"
      }, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[12] || (_cache[12] = _createElementVNode("span", { class: "dataset-label" }, "Mode:", -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.workflowMode) = $event)),
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleWorkflowModeChange && _ctx.handleWorkflowModeChange(...args)))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workflowOptions, (mode) => {
              return (_openBlock(), _createElementBlock("option", {
                key: mode.value,
                value: mode.value
              }, _toDisplayString(mode.label), 9, _hoisted_5))
            }), 128))
          ], 544), [
            [_vModelSelect, _ctx.workflowMode]
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[14] || (_cache[14] = _createElementVNode("span", { class: "dataset-label" }, "Case:", -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedDataset) = $event)),
            onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.changeDataset && _ctx.changeDataset(...args)))
          }, [
            _cache[13] || (_cache[13] = _createElementVNode("option", {
              value: "",
              disabled: ""
            }, "Select Case", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.datasetOptions, (option) => {
              return (_openBlock(), _createElementBlock("option", {
                key: option.value,
                value: option.value
              }, _toDisplayString(option.label), 9, _hoisted_7))
            }), 128))
          ], 544), [
            [_vModelSelect, _ctx.selectedDataset]
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            class: _normalizeClass(["upload-btn", { loading: _ctx.isUploading }]),
            disabled: _ctx.isUploading,
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.triggerFileDialog && _ctx.triggerFileDialog(...args)))
          }, [
            (!_ctx.isUploading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Upload File"))
              : (_openBlock(), _createElementBlock("span", _hoisted_11, _cache[15] || (_cache[15] = [
                  _createElementVNode("span", {
                    class: "spinner",
                    "aria-hidden": "true"
                  }, null, -1),
                  _createTextVNode(" Generating... ")
                ])))
          ], 10, _hoisted_9),
          _createElementVNode("input", {
            ref: "uploadInput",
            type: "file",
            accept: ".csv",
            onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleFileUpload && _ctx.handleFileUpload(...args)))
          }, null, 544)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("button", {
            class: "upload-btn",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.showExportDialog && _ctx.showExportDialog(...args)))
          }, "Export")
        ])
      ])
    ]),
    (_ctx.isEmpty)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createVNode(_component_el_empty, {
            image: require('../../public/nodata.svg'),
            "image-size": 200,
            description: "Please Choose Validation Card"
          }, null, 8, ["image"])
        ]))
      : _createCommentVNode("", true),
    _cache[19] || (_cache[19] = _createElementVNode("div", { id: "view" }, null, -1)),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.showApiConfigDialog,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.showApiConfigDialog) = $event)),
      title: "API Configuration",
      width: "520px",
      "append-to-body": "",
      "close-on-click-modal": false,
      "show-close": !_ctx.apiConfigSaving,
      onClose: _ctx.handleApiConfigCancel
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", null, [
          _createVNode(_component_el_button, {
            disabled: _ctx.apiConfigSaving,
            onClick: _ctx.handleApiConfigCancel
          }, {
            default: _withCtx(() => _cache[17] || (_cache[17] = [
              _createTextVNode(" Cancel ")
            ])),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createVNode(_component_el_button, {
            type: "primary",
            loading: _ctx.apiConfigSaving,
            onClick: _ctx.handleApiConfigSave
          }, {
            default: _withCtx(() => _cache[18] || (_cache[18] = [
              _createTextVNode(" Save ")
            ])),
            _: 1
          }, 8, ["loading", "onClick"])
        ])
      ]),
      default: _withCtx(() => [
        (_ctx.apiConfigLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, "Loading..."))
          : (_openBlock(), _createBlock(_component_el_form, {
              key: 1,
              "label-width": "110px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "Provider" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.apiConfigForm.apiProvider,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.apiConfigForm.apiProvider) = $event)),
                      style: {"width":"100%"},
                      onChange: _ctx.handleApiProviderChange
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.apiProviderOptions, (option) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: option.value,
                            label: option.label,
                            value: option.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "API Key" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.apiConfigForm.apiKey,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.apiConfigForm.apiKey) = $event)),
                      type: "password",
                      "show-password": "",
                      autocomplete: "off",
                      placeholder: "Enter API key"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                (_ctx.providerUsesBaseUrl(_ctx.apiConfigForm.apiProvider))
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      label: "Base URL"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.apiConfigForm.baseUrl,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.apiConfigForm.baseUrl) = $event)),
                          autocomplete: "off",
                          placeholder: "Enter base URL"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_form_item, { label: "Model" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.apiConfigForm.model,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.apiConfigForm.model) = $event)),
                      autocomplete: "off",
                      placeholder: "Enter model name"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
      ]),
      _: 1
    }, 8, ["modelValue", "show-close", "onClose"])
  ]))
}